<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/SysUser/EntryUserList' }">入职管理</el-breadcrumb-item>
                        <el-breadcrumb-item>发起入职</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-col :span="4">
                <el-container>
                    <el-aside style="width:100%;">
                        <el-input style="margin-bottom:12px" size="small" placeholder="输入关键字进行过滤"
                            v-model="filterText"></el-input>

                        <el-tree class="filter-tree" :data="data" v-loading="loading" :props="defaultProps" node-key="id"
                            @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
                            <span class="custom-tree-node" slot-scope="{ node }">
                                <span style="font-size:14px;height:40px;">{{ node.label }}</span>
                            </span>
                        </el-tree>
                    </el-aside>
                </el-container>
            </el-col>
            <el-col :span="20">
                <el-form :model="UserInfoView" :rules="rules" ref="UserInfoView" label-width="100px" class="demo-ruleForm">
                    <el-row class="font_left">
                        <el-col :span="24">
                            <el-row class="font_left">
                                <el-col :span="6">
                                    <el-form-item size="small" label="姓名" label-width="150px" prop="TrueName">
                                        <el-input v-model="UserInfoView.TrueName" placeholder="请输入员工姓名"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="是否添加到钉钉" label-width="200px">
                                        <el-switch v-model="UserInfoView.IsAddDing"></el-switch>
                                    </el-form-item>
                                    <el-form-item size="small" label="部门" label-width="150px" prop="MainDeptsName">
                                        <el-input v-model="UserInfoView.MainDeptsName" :disabled="true"
                                            placeholder="请选择当前部门"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="薪酬体系" label-width="150px" prop="SalaryID">
                                        <el-select v-model="UserInfoView.SalaryID" clearable filterablel
                                            @change="selectGetSalary" placeholder="请选择薪酬体系">
                                            <el-option v-for="v in type" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="现有薪级" label-width="150px" prop="RankID">
                                        <el-select v-model="UserInfoView.RankID" clearable filterable
                                            @change="selectGetRank" placeholder="请选择现有薪级">
                                            <el-option v-for="v in ranks" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="转正后薪档" label-width="150px" prop="RegularLevelId">
                                        <el-select v-model="UserInfoView.RegularLevelId" clearable filterable
                                            @change="selectGetRegularLeve" placeholder="请选择岗位类别">
                                            <el-option v-for="v in levels" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="用工类型" label-width="150px" prop="ContractType">
                                        <el-select v-model="UserInfoView.ContractType" placeholder="请选择用工类型">
                                            <el-option label="全职" value="全职"></el-option>
                                            <el-option label="兼职" value="兼职"></el-option>
                                            <el-option label="实习生" value="实习生"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="个人手机号" label-width="150px" prop="Phone">
                                        <el-input v-model="UserInfoView.Phone" @blur="CheckPhone"
                                            placeholder="请输入手机号"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="保育绩效" label-width="150px">
                                        <el-input v-model="UserInfoView.NursingPerformance"
                                            placeholder="请输入保育绩效"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="推荐人名字和工号" label-width="150px">
                                        <el-input v-model="UserInfoView.Referees" placeholder="推荐人名字和工号"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="电脑型号" label-width="150px">
                                        <el-input v-model="UserInfoView.ComputerModels" placeholder="请输入电脑型号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item size="small" label="员工编号" label-width="150px" prop="UserCode">
                                        <el-input v-model="UserInfoView.UserCode" style="width:180px;margin-right:10px;"
                                            :disabled="true" placeholder="点击按钮写入员工编号"></el-input>
                                        <el-button @click="getUserCode" size="small">生成员工编号</el-button>
                                    </el-form-item>
                                    <el-form-item size="small" label="是否添加到企业微信" label-width="200px">
                                        <el-switch v-model="UserInfoView.IsAddEnterpriseWeChat"></el-switch>
                                    </el-form-item>
                                    <el-form-item size="small" label="职务" label-width="150px" prop="PositionId">
                                        <el-select v-model="UserInfoView.PositionId" clearable filterable
                                            @change="selectGetPosition" placeholder="请选择职务">
                                            <el-option v-for="v in positionArray" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="岗位类别" label-width="150px" prop="DutyTypeId">
                                        <el-select v-model="UserInfoView.DutyTypeId" clearable filterable
                                            @change="selectGetDutyType" placeholder="请选择岗位类别">
                                            <el-option v-for="v in dutyType" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="现有薪档" label-width="150px" prop="LevelID">
                                        <el-select v-model="UserInfoView.LevelID" clearable filterable
                                            @change="selectGetLevel" placeholder="请选择现有薪档">
                                            <el-option v-for="v in levels" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label-width="150px" label="入职时间" prop="HiredDate">
                                        <el-date-picker type="date" placeholder="选择入职时间"
                                            v-model="UserInfoView.HiredDate"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="small" label-width="150px" label="合同开始时间" prop="ContractBegin">
                                        <el-date-picker type="date" placeholder="选择合同开始时间"
                                            v-model="UserInfoView.ContractBegin"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="small" label="是否转正" label-width="150px" prop="IsRegular">
                                        <el-select v-model="UserInfoView.IsRegular" placeholder="请选择是否转正">
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="入职备注" label-width="150px">
                                        <el-input v-model="UserInfoView.Remarks" placeholder="请输入入职备注"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="入职推荐奖金" label-width="150px">
                                        <el-input v-model="UserInfoView.RecommendBonus" placeholder="请输入入职推荐奖金"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="电脑配置" label-width="150px">
                                        <el-input v-model="UserInfoView.ComputerConfiguration"
                                            placeholder="请输入电脑配置"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item size="small" label="员工邮箱" label-width="150px" prop="UserName">
                                        <el-input v-model="UserInfoView.UserName" @blur="CheckUserName"
                                            placeholder="请输入公司邮箱"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="是否添加到邮箱" label-width="200px">
                                        <el-switch v-model="UserInfoView.IsAddTecentMail"></el-switch>
                                    </el-form-item>
                                    <el-form-item size="small" label="岗位" label-width="150px" prop="DutyId">
                                        <el-select v-model="UserInfoView.DutyId" clearable filterable
                                            @change="selectGetDuty" placeholder="请选择岗位">
                                            <el-option v-for="v in duty" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="招聘来源" label-width="150px" prop="recruitincome">
                                        <el-select v-model="UserInfoView.recruitincome" clearable filterable
                                            placeholder="请选择招聘来源">
                                            <el-option label="智联招聘" value="智联招聘"></el-option>
                                            <el-option label="BOSS直聘" value="BOSS直聘"></el-option>
                                            <el-option label="猎聘网" value="猎聘网"></el-option>
                                            <el-option label="前程无忧" value="前程无忧"></el-option>
                                            <el-option label="58同城" value="58同城"></el-option>
                                            <el-option label="赶集网" value="赶集网"></el-option>
                                            <el-option label="员工推荐（常规）" value="员工推荐（常规）"></el-option>
                                            <el-option label="员工推荐（专案）" value="员工推荐（专案）"></el-option>
                                            <el-option label="员工回流" value="员工回流"></el-option>
                                            <el-option label="自招" value="自招"></el-option>
                                            <el-option label="人脉介绍" value="人脉介绍"></el-option>
                                            <el-option label="人才库" value="人才库"></el-option>
                                            <el-option label="脉脉" value="脉脉"></el-option>
                                            <el-option label="领英" value="领英"></el-option>
                                            <el-option label="现场招聘" value="现场招聘"></el-option>
                                            <el-option label="校园招聘" value="校园招聘"></el-option>
                                            <el-option label="猎头招聘" value="猎头招聘"></el-option>
                                            <el-option label="本地人才信息网" value="本地人才信息网"></el-option>
                                            <el-option label="高校就业信息网" value="高校就业信息网"></el-option>
                                            <el-option label="工作啦平台" value="工作啦平台"></el-option>
                                            <el-option label="拉勾网" value="拉勾网"></el-option>
                                            <el-option label="百事通" value="百事通"></el-option>
                                            <el-option label="微招聘" value="微招聘"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="转正后薪级" label-width="150px" prop="RegularRankId">
                                        <el-select v-model="UserInfoView.RegularRankId" clearable filterable
                                            @change="selectGetRegularRank" placeholder="请选择现有薪级">
                                            <el-option v-for="v in ranks" :label="v.ClassName" :key="v.Id"
                                                :value="v.Id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label-width="150px" label="计薪时间" prop="SalaryDate">
                                        <el-date-picker type="date" placeholder="选择计薪时间"
                                            v-model="UserInfoView.SalaryDate"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="small" label-width="150px" label="合同结束时间" prop="ContractEnd">
                                        <el-date-picker type="date" placeholder="选择合同结束时间"
                                            v-model="UserInfoView.ContractEnd"></el-date-picker>
                                    </el-form-item>
                                    <el-form-item size="small" label="保险办理情况" label-width="150px" prop="InsuranceStatus">
                                        <el-select v-model="UserInfoView.InsuranceStatus" placeholder="请选择保险办理情况">
                                            <el-option label="是" value="1"></el-option>
                                            <el-option label="否" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item size="small" label="保险特殊情况" label-width="150px">
                                        <el-input v-model="UserInfoView.InsuranceSpecial"
                                            placeholder="请输入保险特殊情况"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="渠道来源" label-width="150px">
                                        <el-input v-model="UserInfoView.SourceFor" placeholder="请输入渠道来源"></el-input>
                                    </el-form-item>
                                    <el-form-item size="small" label="转正推荐奖金" label-width="150px">
                                        <el-input v-model="UserInfoView.PositiveRecommendBonus"
                                            placeholder="请输入转正推荐奖金"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="mar_top_20">
                        <el-button type="primary" @click="submitForm(UserInfoView)">保存</el-button>
                        <el-button @click="cancle">取消</el-button>
                    </el-row>
                </el-form>
            </el-col>
        </el-card>
    </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetSysItemListByParentID, GetSysItemListByFrameID } from "../../until/ZeusApiSDK/Logic/SysItemLogic";
import { GetUserCode, InsertUserInfo, CheckUserName, CheckPhone } from "../../until/ZeusApiSDK/Logic/SysUserLogic";
import { GetGuid } from '../../until/ZeusApiSDK/Logic/HomeLogic';
import { PostProxyByUrl } from '../../until/ZeusApiSDK/ZeusAPIClient';
import { SetFullUser } from '../../until/ZeusApiSDK/Logic/LogLogic';
import { GetFrameTreeList } from "../../until/ZeusApiSDK/Logic/Frame";
export default {
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        },

    },
    data() {
        return {
            currentUser: {},//当前登录用户信息
            userId: '',//当前用户id
            type: [],//薪资体系
            dutyType: [],//岗位类别
            filterText: '',
            duty: [],//岗位
            ranks: [],//薪级
            levels: [],//薪档
            positionArray: [
                { Id: '100', ClassName: 'CEO' },
                { Id: '101', ClassName: '副总' },
                { Id: '102', ClassName: '总经理' },
                { Id: '103', ClassName: '总监' },
                { Id: '113', ClassName: '高级经理' },
                { Id: '104', ClassName: '大区经理' },
                { Id: '105', ClassName: '经理' },
                { Id: '115', ClassName: '专业经理' },
                //{Id:'106',ClassName:'行业经理'},
                //{Id:'107',ClassName:'见习经理'},
                //{Id:'108',ClassName:'储备经理'},
                { Id: '109', ClassName: '主管' },
                { Id: '110', ClassName: '专员' },
                { Id: '114', ClassName: '/' },
            ],//职务
            drawer: false,//是否打开抽屉
            loading: true,//是否加载中
            data: [],//树状节点
            UserInfoView: {
                InsuranceSpecial: '',//保险的特殊情况
                UserId: '',//当前操作人id
                ComputerConfiguration: '',//电脑配置
                ComputerModels: '',//电脑编号
                ContractType: '',//合同类型
                ContractBegin: '',//合同开始时间
                ContractEnd: '',//合同结束时间
                SourceFor: '',//渠道来源
                Referees: '',//推荐人和推荐人工号
                RecommendBonus: '',//入职推荐奖金
                PositiveRecommendBonus: '',//转正推荐奖金 
                Remarks: '',//入职备注
                TrueName: '',//姓名
                CompanyID: '',//公司编号
                CompanyName: '',//公司名
                CenterID: '',//大中心编号
                CenterName: '',//大中心名称
                GroupID: '',//小中心编号
                GroupName: '',//小中心名称
                MainDeptsName: '',//部门名称
                MainDeptsID: '',//部门编号
                PositionId: '',//员工职务编号
                PositionName: '',//员工职务名称
                DutyTypeId: '',//岗位类别id
                DutyType: '',//岗位类别
                DutyId: '',//岗位id
                Duty: '',//岗位
                UserCode: '',//员工编号
                UserName: '',//邮箱
                SalaryType: '',//薪资类别
                SalaryID: '',//薪资类别编号
                RankName: '',//职级名称
                RankID: '',//职级编号
                LevelName: '',//薪档名称
                LevelID: '',//薪档编号
                RegularRankId: '',//转正后职级id
                RegularRankName: '',//转正后职级名称
                RegularLevelId: '',//转正后薪档编号
                RegularLevelName: '',//转正后薪档名称
                HiredDate: '',//入职时间
                SalaryDate: '',//计薪时间
                IsRegular: '',//是否转正:1是，0否
                RegularDate: '',//转正时间
                Phone: '',//电话号码
                InsuranceStatus: '',//保险办理情况:1是，0否
                RecruitIncome: '',//招聘来源
                IsAddTecentMail: false,//是否添加邮箱
                IsAddDing: false,//是否添加钉钉
                IsAddEnterpriseWeChat: true,//是否添加企业微信
                NursingPerformance: '',//保育绩效
            },//修改前数据信息
            imageUrl: '',//上传图片路径地址
            //表单规则验证
            rules: {
                NursingPerformance: [
                    { required: true, message: '保育绩效必须为数字值', trigger: 'blur' }
                ],
                TrueName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                MainDeptsName: [
                    { required: true, message: '请根据左边树状结构选择部门', trigger: 'change' }
                ],
                UserCode: [
                    { required: true, message: '请点击按钮填入工号', trigger: 'blur' }
                ],
                UserName: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },

                ],
                PositionId: [
                    { required: true, message: '请选择职务', trigger: 'change' }
                ],
                DutyTypeId: [
                    { required: true, message: '请选择岗位类别', trigger: 'change' }
                ],
                DutyId: [
                    { required: true, message: '请选择岗位', trigger: 'change' }
                ],
                recruitincome: [
                    { required: true, message: '请选择招聘来源', trigger: 'change' }
                ],
                SalaryID: [
                    { required: true, message: '请选择薪酬体系', trigger: 'change' }
                ],
                RankID: [
                    { required: true, message: '请选择现有薪级', trigger: 'change' }
                ],
                LevelID: [
                    { required: true, message: '请选择现有薪档', trigger: 'change' }
                ],
                RegularRankId: [
                    { required: true, message: '请选择转正后薪级', trigger: 'change' }
                ],
                RegularLevelId: [
                    { required: true, message: '请选择转正后薪档', trigger: 'change' }
                ],
                HiredDate: [
                    { required: true, message: '请选择入职时间', trigger: 'change' }
                ],
                SalaryDate: [
                    { required: true, message: '请选择计薪时间', trigger: 'change' }
                ],
                ContractType: [
                    { required: true, message: '请选择用工类型', trigger: 'change' }
                ],
                ContractBegin: [
                    { required: true, message: '请选择合同开始时间', trigger: 'change' }
                ],
                ContractEnd: [
                    { required: true, message: '请选择合同结束时间', trigger: 'change' }
                ],
                IsRegular: [
                    { required: true, message: '请选择是否转正', trigger: 'change' }
                ],
                InsuranceStatus: [
                    { required: true, message: '请选择保险办理情况', trigger: 'change' }
                ],
                Phone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' },

                ],
            },
            defaultProps: {
                children: 'children',
                label: 'label',
                disabled: 'type'
            }
        }
    },
    methods: {



        // //检测手机号
        CheckPhone() {
            if (this.UserInfoView.Phone != null && this.UserInfoView.Phone != "") {
                CheckPhone(this.UserInfoView.Phone).then(res => {
                    if (res) {
                        this.$message({
                            showClose: true,
                            message: '手机号已存在',
                            type: 'warning',
                            offset: '400'
                        });

                    }
                });
            }

        },
        // //检测邮箱名字
        CheckUserName() {
            if (this.UserInfoView.UserName != null && this.UserInfoView.UserName != "") {
                CheckUserName(this.UserInfoView.UserName).then(res => {
                    if (!res) {

                        this.$message({
                            showClose: true,
                            message: '邮箱无效或已存在',
                            type: 'warning',
                            offset: '400'
                        });
                    }
                });
            }

        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        //获取当前用户
        getCurrentUser: function () {
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取薪资体系，岗位类别，岗位信息等
        GetSysItemListByParentID: function () {
            //获取薪酬体系
            GetSysItemListByParentID('9').then(res => {
                this.type = res;
            });
            //获取岗位类别
            GetSysItemListByParentID('7').then(res => {
                this.dutyType = res;
            });
            //获取岗位
            GetSysItemListByParentID('8').then(res => {
                this.duty = res;
            });
            //获取薪级
            GetSysItemListByParentID('3').then(res => {
                this.ranks = res;
            });
            //获取薪档
            GetSysItemListByParentID('4').then(res => {
                this.levels = res;
            });
        },
        //获取部门树
        GetFrameTree: async function () {
            //获取部门信息
            await GetFrameTreeList().then(res => {
                this.loading = false;
                this.data = JSON.parse(res);
            });
        },
        //部门树节点点击
        handleNodeClick: function (data) {
            //console.log('data',data);
            this.UserInfoView.MainDeptsName = data.label;
            this.UserInfoView.MainDeptsID = data.Id;
            if (data.level == 202) {
                //获取中心下岗位
                GetSysItemListByFrameID(data.Id).then((res) => {
                    this.duty = res;
                });
            }
        },
        //获取员工编号
        getUserCode: function () {
            //获取员工编号
            GetUserCode().then(res => {
                this.UserInfoView.UserCode = res;
            });
        },
        //获取薪酬体系名称
        selectGetSalary: async function (vId) {
            let obj = {};
            obj = await this.type.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.SalaryType = item.ClassName;
                }
            });
        },
        //现有薪级
        selectGetRank: async function (vId) {
            let obj = {};
            obj = await this.ranks.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.RankName = item.ClassName;
                }
            });
        },
        //转正后薪档
        selectGetRegularLeve: async function (vId) {
            let obj = {};
            obj = await this.levels.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.RegularLevelName = item.ClassName;
                }
            });
        },
        //职务 
        selectGetPosition: async function (vId) {
            let obj = {};
            obj = await this.positionArray.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.PositionName = item.ClassName;
                }
            });
        },
        //岗位类别
        selectGetDutyType: async function (vId) {
            let obj = {};
            obj = await this.dutyType.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.DutyType = item.ClassName;
                }
            });
        },
        //现有薪档
        selectGetLevel: async function (vId) {
            let obj = {};
            obj = await this.levels.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.LevelName = item.ClassName;
                }
            });
        },
        //岗位
        selectGetDuty: async function (vId) {
            let obj = {};
            obj = await this.duty.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.Duty = item.ClassName;
                }
            });
        },
        //转正后薪级
        selectGetRegularRank: async function (vId) {
            let obj = {};
            obj = await this.ranks.find((item) => {//这里的userList就是上面遍历的数据源
                if (item.Id == vId) {
                    this.UserInfoView.RegularRankName = item.ClassName;
                }
            });
        },
        //提交信息
        submitForm: async function (formInfo) {
            this.$refs['UserInfoView'].validate((valid) => {
                if (valid) {
                    //转换入职时间  时间格式
                    if (formInfo.HiredDate != '' && formInfo.HiredDate != null) {
                        const hired = new Date(formInfo.HiredDate);
                        const hiredDate = hired.getFullYear() + '-' + this.p((hired.getMonth() + 1)) + '-' + this.p(hired.getDate());
                        formInfo.HiredDate = hiredDate;
                    }
                    //转换计薪时间  时间格式
                    if (formInfo.SalaryDate != '' && formInfo.SalaryDate != null) {
                        const salary = new Date(formInfo.SalaryDate);
                        const salaryDate = salary.getFullYear() + '-' + this.p((salary.getMonth() + 1)) + '-' + this.p(salary.getDate());
                        formInfo.SalaryDate = salaryDate;
                    }
                    //转换合同开始时间  时间格式
                    if (formInfo.ContractBegin != '' && formInfo.ContractBegin != null) {
                        const contractBegin = new Date(formInfo.ContractBegin);
                        const contractBeginDate = contractBegin.getFullYear() + '-' + this.p((contractBegin.getMonth() + 1)) + '-' + this.p(contractBegin.getDate());
                        formInfo.ContractBegin = contractBeginDate;
                    }
                    //转换合同结束时间  时间格式
                    if (formInfo.ContractEnd != '' && formInfo.ContractEnd != null) {
                        const contractEnd = new Date(formInfo.ContractEnd);
                        const contractEndDate = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
                        formInfo.ContractEnd = contractEndDate;
                    }
                    //添加当前操作人
                    formInfo.UserId = this.currentUser.UserId;
                    InsertUserInfo(formInfo).then(res => {
                        if (res) {
                            //添加成功 添加日志 并跳转到入职管理页
                            this.addLog(formInfo);
                            this.$router.push('/SysUser/EntryUserList');
                        } else {
                            this.$message.error('提交失败！！');
                        }
                    });
                } else {
                    this.$message.error('请补全信息！！');
                    return false;
                }
            });
        },
        //取消 跳转到详情页
        cancle: function () {
            this.$router.go(-1);
        },
        //时间转换 不够10 添加0
        p(s) {
            return s < 10 ? '0' + s : s
        },
        //添加日志
        addLog: function (formInfo) {
            //编辑sysUser成功，添加日志
            SetFullUser("发起入职sysUser",
                this.currentUser.UserId,
                this.currentUser.TrueName,
                "发起入职",
                '发起入职成功',
                formInfo.UserCode,
                formInfo,
                {},
                "userInfoModel");

        },
        //返回上一级
        toBack: function () {
            this.$router.go(-1);
        }
    },
    //页面进入加载事件
    created: function () {
        //获取当前用户
        this.getCurrentUser();
        //获取部门树状结构信息
        this.GetFrameTree();
        //获取薪资体系，岗位类别，岗位信息等
        this.GetSysItemListByParentID();
    },
}
</script>
<style lang="less" scoped>
.font_left {
    text-align: left;
}

.font_right {
    text-align: right;
}

.img_size {
    width: 100%;
    // padding:20px;
}

.img_size_80 {
    width: 60%;
    // padding:20px;
}

.div_name {
    font-size: 30px;
    margin-right: 30px;
}

.mar_top_10 {
    margin-top: 10px;
}

.mar_top_20 {
    margin-top: 20px;
    margin-bottom: 20px;
}

.mar_left_10 {
    margin-right: 10px;
}

.border_bottom {
    margin-top: 26px;
    border-bottom: 1px dotted #d9d9d9;
}

.height_50 {
    height: 50px;
}

.height_45 {
    height: 45px;
}

//图片上传样式开始 .avatar-uploader
.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

//图片上传样式结束
</style>